export { default } from './GridCites.vue'
